<template>
	<v-container fluid>
		<v-row dense>
			<!-- Facilities -->
			<v-col cols="12" md="6">
				<v-card height="42vh" elevation="5" class="overflow-hidden" :loading="facilitiesTableLoader">
					<div class="d-flex justify-space-between elevation-3">
						<div class="d-flex align-center">
							<v-img :src="organizationsBlack" class="ml-2" max-height="21" max-width="22"></v-img>
							<div class="text-left my-2 ml-2 mb-2 font-weight-bold font-size16">
								{{ $t('organization-facilities') }}
							</div>
						</div>
						<div>
							<v-text-field
								single-line
								outlined
								class="py-1 px-1"
								prepend-inner-icon="mdi-magnify"
								hide-details
								dense
								v-model="facilitySearch"
								:label="$t('search')"></v-text-field>
						</div>
					</div>
					<v-divider></v-divider>
					<div>
						<v-data-table
							:no-data-text="$t('no-data-available')"
							:loading-text="$t('loading')"
							:items="filteredBillings"
							:headers="facilityHeaders"
							item-key="patientId"
							fixed-header
							:loading="loader"
							dense
							:search="facilitySearch"
							ref="table"
							class="mx-0 px-0"
							height="31vh"
							max-height="380"
							group-by="hospitalData.id"
							:items-per-page="-1"
							:footer-props="getDataTableFooterProps('dashboardOrgTable')">
							<template #[`group.header`]="{ items, toggle, isOpen, group }">
								<td @click="toggle" class="elevation-1 px-1 py-0 white-background" :colspan="facilityHeaders.length">
									<v-row class="px-0" dense @click="handleFacilityClick(items[0])">
										<div class="d-flex align-center mb-n1">
											<v-btn small icon :ref="group" :data-open="isOpen" class="color-black">
												<v-icon small v-if="isOpen" color="primary">mdi-arrow-down-drop-circle</v-icon>
												<v-icon small v-else color="primary">mdi-arrow-right-drop-circle</v-icon>
											</v-btn>
										</div>
										<v-col class="text-left font-weight-medium font-size12-5" cols="3" v-if="items && items.length > 0">
											{{ items[0].hospitalData.hospitalName }}
										</v-col>
										<v-col class="font-size12-5">
											<span class="justify-center">
												{{ findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter99445 }}/{{
													findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter
												}}
											</span>
											<v-chip x-small class="float-right font-weight-bold" style="min-width: 50px">
												{{
													(
														(findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter99445 /
															findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter) *
														100
													).toFixed(1)
												}}%
											</v-chip>
										</v-col>
										<v-col class="font-size12-5">
											<span class="justify-center">
												{{ findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter99454 }}/{{
													findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter
												}}
											</span>
											<v-chip x-small class="float-right font-weight-bold" style="min-width: 50px">
												{{
													(
														(findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter99454 /
															findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter) *
														100
													).toFixed(1)
												}}%
											</v-chip>
										</v-col>
										<v-col class="font-size12-5">
											<span class="justify-center">
												{{ findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter99470 }}/{{
													findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter
												}}
											</span>
											<v-chip x-small class="float-right font-weight-bold" style="min-width: 50px">
												{{
													(
														(findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter99470 /
															findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter) *
														100
													).toFixed(1)
												}}%
											</v-chip>
										</v-col>
										<v-col class="font-size12-5">
											<span class="justify-center">
												{{ findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter99457 }}/{{
													findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter
												}}
											</span>
											<v-chip x-small class="float-right font-weight-bold" style="min-width: 50px">
												{{
													(
														(findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter99457 /
															findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter) *
														100
													).toFixed(1)
												}}%
											</v-chip>
										</v-col>
										<v-col class="font-size12-5">
											<span class="justify-center">
												{{ findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter994581st }}/{{
													findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter
												}}
											</span>
											<v-chip x-small class="float-right font-weight-bold" style="min-width: 50px">
												{{
													(
														(findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter994581st /
															findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter) *
														100
													).toFixed(1)
												}}%
											</v-chip>
										</v-col>
										<v-col class="font-size12-5">
											<span class="justify-center">
												{{ findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter994582nd }}/{{
													findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter
												}}
											</span>
											<v-chip x-small class="float-right font-weight-bold" style="min-width: 50px">
												{{
													(
														(findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter994582nd /
															findBillingUnitsbyHospitalIdV2(items[0].hospitalId)?.counter) *
														100
													).toFixed(1)
												}}%
											</v-chip>
										</v-col>
									</v-row>
								</td>
							</template>

							<template #item="{ item, index }">
								<tr style="height: 7px !important" v-if="index === 0">
									<td
										class="color-header text-left"
										v-for="(header, index) in insideHeaders"
										:key="index"
										style="height: 7px !important"
										:colspan="1">
										<span class="font-weight-medium font-size11">{{ header.text }}</span>
									</td>
								</tr>
								<tr :class="getRowsForDataTable(index)" @click="handlePatientClick(item)">
									<td class="text-left font-size12 font-weight-medium">
										<v-tooltip color="gray" top>
											<template #activator="{ on, attrs }">
												<div v-bind="attrs" v-on="on">
													<span>{{ item.patientData?.firstName }} {{ item.patientData?.lastName }}</span>
												</div>
											</template>
											<div>
												<v-progress-linear
													style="width: 200px"
													class="white--text my-2"
													striped
													rounded
													:value="getPatientProgressForCPTCode(item.myBillings?.percent99445)"
													:color="progressColorForPatient(getPatientProgressForCPTCode(item.myBillings?.percent99445))"
													height="15">
													99445: {{ getPatientProgressForCPTCode(item.myBillings?.percent99445) }} %
												</v-progress-linear>

												<!-- First progress bar for 99454 CPT code -->
												<v-progress-linear
													style="width: 200px"
													class="white--text my-2"
													striped
													rounded
													:value="getPatientProgressForCPTCode(item.myBillings?.percent99454)"
													:color="progressColorForPatient(getPatientProgressForCPTCode(item.myBillings?.percent99454))"
													height="15">
													99454: {{ getPatientProgressForCPTCode(item.myBillings?.percent99454) }} %
												</v-progress-linear>

												<!-- Second progress bar for 99457 CPT code -->
												<v-progress-linear
													style="width: 200px"
													class="white--text my-2"
													striped
													rounded
													:value="getPatientProgressForCPTCode(item.myBillings?.percent99470)"
													:color="progressColorForPatient(getPatientProgressForCPTCode(item.myBillings?.percent99470))"
													height="15">
													99470: {{ getPatientProgressForCPTCode(item.myBillings?.percent99470) }} %
												</v-progress-linear>

												<!-- Second progress bar for 99457 CPT code -->
												<v-progress-linear
													style="width: 200px"
													class="white--text my-2"
													striped
													rounded
													:value="getPatientProgressForCPTCode(item.myBillings?.percent99457)"
													:color="progressColorForPatient(getPatientProgressForCPTCode(item.myBillings?.percent99457))"
													height="15">
													99457: {{ getPatientProgressForCPTCode(item.myBillings?.percent99457) }} %
												</v-progress-linear>

												<!-- Third progress bar for 99458 1st CPT code -->
												<v-progress-linear
													style="width: 200px"
													class="white--text my-2"
													striped
													rounded
													:value="getPatientProgressForCPTCode(item.myBillings?.percent994581st)"
													:color="
														progressColorForPatient(getPatientProgressForCPTCode(item.myBillings?.percent994581st))
													"
													height="15">
													99458 1st: {{ getPatientProgressForCPTCode(item.myBillings?.percent994581st) }} %
												</v-progress-linear>

												<!-- Fourth progress bar for 99458 2nd CPT code -->
												<v-progress-linear
													style="width: 200px"
													class="white--text my-2"
													striped
													rounded
													:value="getPatientProgressForCPTCode(item.myBillings?.percent994582nd)"
													:color="
														progressColorForPatient(getPatientProgressForCPTCode(item.myBillings?.percent994582nd))
													"
													height="15">
													99458 2nd: {{ getPatientProgressForCPTCode(item.myBillings?.percent994582nd) }} %
												</v-progress-linear>
											</div>
											<!--                      <span>{{ item.patientData?.firstName }} {{ item.patientData?.lastName }}</span>-->
										</v-tooltip>
									</td>

									<td class="text-left font-size12 font-weight-medium">
										<div class="d-flex">
											<v-icon size="16" class="mr-2" v-if="item.myBillings?.m99445IsBillable" color="primary">
												mdi-checkbox-blank
											</v-icon>
											<v-icon size="16" class="mr-2" v-else color="black">mdi-checkbox-blank-outline</v-icon>
											<v-chip
												:color="item.myBillings?.percent99445 >= 100 ? 'primary' : ''"
												v-show="item.myBillings?.totalMeasurements99445 !== 0"
												label
												pill
												x-small>
												{{ item.myBillings?.totalMeasurements99445 }}
											</v-chip>
										</div>
									</td>
									<td class="text-left font-size12 font-weight-medium">
										<div class="d-flex">
											<v-icon size="16" class="mr-2" v-if="item.myBillings?.m99454IsBillable" color="primary">
												mdi-checkbox-blank
											</v-icon>
											<v-icon size="16" class="mr-2" v-else color="black">mdi-checkbox-blank-outline</v-icon>
											<v-chip
												:color="item.myBillings?.totalMeasurements99454 >= 16 ? 'primary' : ''"
												v-show="item.myBillings?.totalMeasurements99454 !== 0"
												label
												pill
												x-small>
												{{ item.myBillings?.totalMeasurements99454 }}
											</v-chip>
										</div>
									</td>
									<td class="text-left font-size12 font-weight-medium">
										<v-icon size="16" class="mr-2" v-if="item.myBillings?.m99470IsBillable" color="primary">
											mdi-checkbox-blank
										</v-icon>
										<v-icon size="16" class="mr-2" v-else color="black">mdi-checkbox-blank-outline</v-icon>
									</td>
									<td class="text-left font-size12 font-weight-medium">
										<v-icon size="16" class="mr-2" v-if="item.myBillings?.m99457IsBillable" color="primary">
											mdi-checkbox-blank
										</v-icon>
										<v-icon size="16" class="mr-2" v-else color="black">mdi-checkbox-blank-outline</v-icon>
									</td>
									<td class="text-left font-size12 font-weight-medium">
										<v-icon size="16" class="mr-2" v-if="item.myBillings?.m994581stIsBillable" color="primary">
											mdi-checkbox-blank
										</v-icon>
										<v-icon size="16" class="mr-2" v-else color="black">mdi-checkbox-blank-outline</v-icon>
									</td>
									<td class="text-left font-size12 font-weight-medium">
										<v-icon size="16" class="mr-2" v-if="item.myBillings?.m994582ndIsBillable" color="primary">
											mdi-checkbox-blank
										</v-icon>
										<v-icon size="16" class="mr-2" v-else color="black">mdi-checkbox-blank-outline</v-icon>
									</td>
									<td></td>
									<td></td>
								</tr>
							</template>
						</v-data-table>
					</div>
				</v-card>
				<v-card height="40vh" elevation="5" class="overflow-auto" :loading="facilitiesTableLoader">
					<div class="d-flex justify-space-between elevation-3">
						<div class="d-flex align-center">
							<v-img :src="info" class="ml-2" max-height="21" max-width="22"></v-img>
							<div class="text-left my-2 ml-2 mb-2 font-weight-bold font-size16">
								{{ $t('organization-users-status-and-billing') }}
							</div>
						</div>
					</div>
					<v-card-text>
						<v-card class="d-flex align-center justify-center full-width py-1">
							<div class="d-flex flex-column align-center font-weight-bold font-size12 black--text px-3">
								{{ $t('active') }}
								<v-avatar color="#09CB09" size="30">
									<span class="white--text">{{ organizationUserStatus.activeUsers }}</span>
								</v-avatar>
							</div>
							<!--              INACTIVE-->
							<div class="d-flex flex-column align-center font-weight-bold font-size12 black--text px-3">
								{{ $t('inactive') }}
								<v-avatar color="gray" size="30">
									<span class="black--text">{{ organizationUserStatus.inactiveUsers }}</span>
								</v-avatar>
							</div>
							<!--              DECEASED-->
							<div class="d-flex flex-column align-center font-weight-bold font-size12 black--text px-3">
								{{ $t('deceased') }}
								<v-avatar color="#000" size="30">
									<span class="white--text">{{ organizationUserStatus.deceasedUsers }}</span>
								</v-avatar>
							</div>
						</v-card>
						<v-card class="d-flex align-center justify-center full-width">
							<v-card-text>
								<div class="text-center my-0 py-0 mb-2">
									<span class="font-size16 font-weight-bold black--text">
										{{ $t('billings') }}: {{ authUserData.organizationAssignedData.institutionName }}
									</span>
								</div>
								<div class="d-flex justify-center">
									<v-tooltip top>
										<template #activator="{ on, attrs }">
											<v-progress-circular
												v-bind="attrs"
												v-on="on"
												class="font-size12 mx-2 px-2 font-weight-bold"
												:rotate="-90"
												:size="80"
												:width="2"
												:value="organizationBillingUnits.BillingUnits99445Percent"
												:color="organizationBillingUnits.BillingUnits99445Percent >= 100 ? 'green' : 'primary'">
												99445 {{ organizationBillingUnits.BillingUnits99445 }}/{{ organizationBillingUnits.userCount }}
											</v-progress-circular>
										</template>
										<span>{{ $t('data-transmission-for-2-to-15-days-within-a-30-day-period') }}</span>
									</v-tooltip>
									<v-tooltip top>
										<template #activator="{ on, attrs }">
											<v-progress-circular
												v-bind="attrs"
												v-on="on"
												class="font-size12 mx-2 px-2 font-weight-bold"
												:rotate="-90"
												:size="80"
												:width="2"
												:value="organizationBillingUnits.BillingUnits99454Percent"
												:color="organizationBillingUnits.BillingUnits99454Percent >= 100 ? 'green' : 'primary'">
												99454 {{ organizationBillingUnits.BillingUnits99454 }}/{{ organizationBillingUnits.userCount }}
											</v-progress-circular>
										</template>
										<span>{{ $t('data-transmission-for-16-days-or-more-within-a-30-day-period') }}</span>
									</v-tooltip>
									<v-tooltip top>
										<template #activator="{ on, attrs }">
											<v-progress-circular
												v-bind="attrs"
												v-on="on"
												class="font-size12 mx-2 px-2 font-weight-bold"
												:rotate="-90"
												:size="80"
												:width="2"
												:value="organizationBillingUnits.BillingUnits99470Percent"
												:color="organizationBillingUnits.BillingUnits99470Percent >= 100 ? 'green' : 'primary'">
												99470 {{ organizationBillingUnits.BillingUnits99470 }}/{{ organizationBillingUnits.userCount }}
											</v-progress-circular>
										</template>
										<span>{{ $t('10-to-19-minutes-of-RPM-time') }}</span>
									</v-tooltip>
									<v-tooltip top>
										<template #activator="{ on, attrs }">
											<v-progress-circular
												v-bind="attrs"
												v-on="on"
												class="font-size12 mx-2 px-2 font-weight-bold"
												:rotate="-90"
												:size="80"
												:width="2"
												:value="organizationBillingUnits.BillingUnits99457Percent"
												:color="organizationBillingUnits.BillingUnits99457Percent >= 100 ? 'green' : 'primary'">
												99457 {{ organizationBillingUnits.BillingUnits99457 }}/{{ organizationBillingUnits.userCount }}
											</v-progress-circular>
										</template>
										<span>{{ $t('20-minutes-of-RPM-time') }}</span>
									</v-tooltip>
									<v-tooltip top>
										<template #activator="{ on, attrs }">
											<v-progress-circular
												v-bind="attrs"
												v-on="on"
												class="font-size12 mx-2 px-2 font-weight-bold"
												:rotate="-90"
												:size="80"
												:width="2"
												:value="organizationBillingUnits.BillingUnits994581stPercent"
												:color="organizationBillingUnits.BillingUnits994581stPercent >= 100 ? 'green' : 'primary'">
												99458 1st {{ organizationBillingUnits.BillingUnits994581st }}/{{
													organizationBillingUnits.userCount
												}}
											</v-progress-circular>
										</template>
										<span>{{ $t('20-additional-minutes-of-RPM-time') }}</span>
									</v-tooltip>
									<v-tooltip top>
										<template #activator="{ on, attrs }">
											<v-progress-circular
												v-bind="attrs"
												v-on="on"
												class="font-size12 mx-2 font-weight-bold"
												:rotate="-90"
												:size="80"
												:width="2"
												:value="organizationBillingUnits.BillingUnits994582ndPercent"
												:color="organizationBillingUnits.BillingUnits994582ndPercent >= 100 ? 'green' : 'primary'">
												99458 2nd {{ organizationBillingUnits.BillingUnits994582nd }}/{{
													organizationBillingUnits.userCount
												}}
											</v-progress-circular>
										</template>
										<span>{{ $t('20-additional-minutes-of-RPM-time') }}</span>
									</v-tooltip>
								</div>
								<v-divider class="mt-3"></v-divider>
								<v-row dense class="d-flex justify-center mt-5" justify="space-around">
									<v-col cols="12">
										<v-card>
											<div class="d-flex align-center pa-2 my-n5">
												<v-progress-linear
													class="white--text"
													striped
													:value="getOverAllProgressForOrganization().toFixed(1)"
													:color="progressColorForOrganization"
													height="25">
													{{ $t('progress') }}: {{ getOverAllProgressForOrganization().toFixed(1) }} %
												</v-progress-linear>
											</div>
										</v-card>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-card-text>
				</v-card>
			</v-col>
			<!-- Billings -->
			<v-col cols="12" md="6">
				<v-card height="42vh" elevation="5" class="overflow-auto">
					<div class="d-flex align-center elevation-3 py-3">
						<v-img class="ml-1" :src="billingsNew" max-height="21" max-width="22"></v-img>
						<div class="text-left font-weight-bold font-size16 ml-1">{{ $t('facility-users-status-and-billing') }}</div>
					</div>
					<v-card-text>
						<v-card class="d-flex align-center justify-center full-width py-1">
							<div class="d-flex flex-column align-center font-weight-bold font-size12 black--text px-3">
								{{ $t('active') }}
								<v-avatar color="#09CB09" size="30">
									<span class="white--text">{{
										facilityUserStatus.activeUsers ? facilityUserStatus.activeUsers : 0
									}}</span>
								</v-avatar>
							</div>
							<!--              INACTIVE-->
							<div class="d-flex flex-column align-center font-weight-bold font-size12 black--text px-3">
								{{ $t('inactive') }}
								<v-avatar color="gray" size="30">
									<span class="black--text">{{
										facilityUserStatus.inactiveUsers ? facilityUserStatus.inactiveUsers : 0
									}}</span>
								</v-avatar>
							</div>
							<!--              DECEASED-->
							<div class="d-flex flex-column align-center font-weight-bold font-size12 black--text px-3">
								{{ $t('deceased') }}
								<v-avatar color="#000" size="30">
									<span class="white--text">{{
										facilityUserStatus.deceasedUsers ? facilityUserStatus.deceasedUsers : 0
									}}</span>
								</v-avatar>
							</div>
						</v-card>
						<v-card>
							<v-card-text>
								<div class="text-center my-0 py-0 mb-2">
									<span class="font-size16 font-weight-bold black--text"
										>{{ $t('billings')
										}}{{
											facilityClicked
												? hospitalName
												: `: ${patientDataObject.patientData?.firstName} ${
														patientDataObject.patientData?.lastName || ''
												  }`
										}}</span
									>
								</div>
								<div class="d-flex justify-center" v-if="facilityClicked">
									<v-tooltip bottom>
										<template #activator="{ on, attrs }">
											<v-progress-circular
												v-bind="attrs"
												v-on="on"
												class="font-size12 mx-1 px-2 font-weight-bold order-0"
												:rotate="-90"
												:size="80"
												:width="1"
												:value="getHospitalSummary(clickedFacilityId)?.percent99445 ?? 0"
												:color="getHospitalSummary(clickedFacilityId)?.percent99445 >= 100 ? 'green' : 'primary'">
												<div class="d-flex flex-column">
													<span> 99445 </span>
													<div>{{ getHospitalSummary(clickedFacilityId)?.percent99445 || '0' }}%</div>
												</div>
											</v-progress-circular>
										</template>
										<span>{{ $t('data-transmission-for-2-to-15-days-within-a-30-day-period') }}</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template #activator="{ on, attrs }">
											<v-progress-circular
												v-bind="attrs"
												v-on="on"
												class="font-size12 mx-1 px-2 font-weight-bold order-1"
												:rotate="-90"
												:size="80"
												:width="1"
												:value="getHospitalSummary(clickedFacilityId)?.percent99454 ?? 0"
												:color="getHospitalSummary(clickedFacilityId)?.percent99454 >= 100 ? 'green' : 'primary'">
												<div class="d-flex flex-column">
													<span> 99454 </span>
													<div>{{ getHospitalSummary(clickedFacilityId)?.percent99454 || '0' }}%</div>
												</div>
											</v-progress-circular>
										</template>
										<span>{{ $t('data-transmission-for-16-days-or-more-within-a-30-day-period') }}</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template #activator="{ on, attrs }">
											<v-progress-circular
												v-bind="attrs"
												v-on="on"
												class="font-size12 mx-1 px-2 font-weight-bold order-2"
												:rotate="-90"
												:size="80"
												:width="1"
												:value="getHospitalSummary(clickedFacilityId)?.percent99470 ?? 0"
												:color="getHospitalSummary(clickedFacilityId)?.percent99470 >= 100 ? 'green' : 'primary'">
												<div class="d-flex flex-column">
													<span> 99470 </span>
													<div>{{ getHospitalSummary(clickedFacilityId)?.percent99470 || '0' }}%</div>
												</div>
											</v-progress-circular>
										</template>
										<span>{{ $t('10-to-19-minutes-of-RPM-time') }}</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template #activator="{ on, attrs }">
											<v-progress-circular
												v-bind="attrs"
												v-on="on"
												class="font-size12 mx-1 px-2 font-weight-bold order-3"
												:rotate="-90"
												:size="80"
												:width="1"
												:value="getHospitalSummary(clickedFacilityId)?.percent99457 ?? 0"
												:color="getHospitalSummary(clickedFacilityId)?.percent99457 >= 100 ? 'green' : 'primary'">
												<div class="d-flex flex-column">
													<span> 99457 </span>
													<div>{{ getHospitalSummary(clickedFacilityId)?.percent99457 || '0' }}%</div>
												</div>
											</v-progress-circular>
										</template>
										<span>{{ $t('20-minutes-of-RPM-time') }}</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template #activator="{ on, attrs }">
											<v-progress-circular
												v-bind="attrs"
												v-on="on"
												class="font-size12 mx-1 px-2 font-weight-bold order-4"
												:rotate="-90"
												:size="80"
												:width="1"
												:value="getHospitalSummary(clickedFacilityId)?.percent994581st ?? 0"
												:color="getHospitalSummary(clickedFacilityId)?.percent994581st >= 100 ? 'green' : 'primary'">
												<div class="d-flex flex-column">
													<span> 99458 1st </span>
													<div>{{ getHospitalSummary(clickedFacilityId)?.percent994581st || '0' }}%</div>
												</div>
											</v-progress-circular>
										</template>
										<span>{{ $t('20-additional-minutes-of-RPM-time') }}</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template #activator="{ on, attrs }">
											<v-progress-circular
												v-bind="attrs"
												v-on="on"
												class="font-size12 mx-1 px-2 font-weight-bold order-5"
												:rotate="-90"
												:size="80"
												:width="1"
												:value="getHospitalSummary(clickedFacilityId)?.percent994582nd ?? 0"
												:color="getHospitalSummary(clickedFacilityId)?.percent994582nd >= 100 ? 'green' : 'primary'">
												<div class="d-flex flex-column">
													<span> 99458 2nd </span>
													<div>{{ getHospitalSummary(clickedFacilityId)?.percent994582nd || '0' }}%</div>
												</div>
											</v-progress-circular>
										</template>
										<span>{{ $t('20-additional-minutes-of-RPM-time') }}</span>
									</v-tooltip>
								</div>
								<div class="d-flex justify-center" v-if="clickedPatient">
									<v-tooltip bottom>
										<template #activator="{ on, attrs }">
											<v-progress-circular
												:rotate="-90"
												:size="80"
												:width="2"
												:value="patientDataObject.myBillings.percent99445"
												:color="patientDataObject.myBillings.percent99445 === 100 ? 'green' : 'primary'"
												class="font-size12 mx-1 px-2 font-weight-bold order-0"
												v-bind="attrs"
												v-on="on">
												<div v-if="patientDataObject.myBillings.m99445IsBillable">
													<v-icon size="16" class="mr-2" color="black">mdi-checkbox-marked-outline</v-icon>
												</div>
												<div class="d-flex flex-column">
													<span>99445</span>
													<div>{{ patientDataObject.myBillings.totalMeasurements99445 }}/2</div>
												</div>
											</v-progress-circular>
										</template>
										<span>{{ $t('data-transmission-for-2-to-15-days-or-more-within-a-30-day-period') }}</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template #activator="{ on, attrs }">
											<v-progress-circular
												:rotate="-90"
												:size="80"
												:width="2"
												:value="patientDataObject.myBillings.percent99454"
												:color="patientDataObject.myBillings.percent99454 === 100 ? 'green' : 'primary'"
												class="font-size12 mx-1 px-2 font-weight-bold order-1"
												v-bind="attrs"
												v-on="on">
												<div v-if="patientDataObject.myBillings.m99454IsBillable">
													<v-icon size="16" class="mr-2" color="black">mdi-checkbox-marked-outline</v-icon>
												</div>
												<div class="d-flex flex-column">
													<span>99454</span>
													<div>{{ patientDataObject.myBillings.totalMeasurements99454 }}/16</div>
												</div>
											</v-progress-circular>
										</template>
										<span>{{ $t('data-transmission-for-16-days-or-more-within-a-30-day-period') }}</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template #activator="{ on, attrs }">
											<v-progress-circular
												:rotate="-90"
												:size="80"
												:width="2"
												:value="patientDataObject.myBillings.percent99470"
												:color="patientDataObject.myBillings.percent99470 === 100 ? 'green' : 'primary'"
												class="font-size12 mx-1 px-2 font-weight-bold order-2"
												v-bind="attrs"
												v-on="on">
												<div class="d-flex flex-column">
													<span> 99470 </span>
													<span>
														{{ secToMinV2(patientDataObject.myBillings.seconds99470) }}
													</span>
												</div>
											</v-progress-circular>
										</template>
										<span>{{ $t('data-transmission-for-2-to-15-days-within-a-30-day-period') }}</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template #activator="{ on, attrs }">
											<v-progress-circular
												:rotate="-90"
												:size="80"
												:width="2"
												:value="patientDataObject.myBillings.percent99457"
												:color="patientDataObject.myBillings.percent99457 === 100 ? 'green' : 'primary'"
												class="font-size12 mx-1 px-2 font-weight-bold order-3"
												v-bind="attrs"
												v-on="on">
												<div class="d-flex flex-column">
													<span> 99457 </span>
													<span>
														{{ secToMinV2(patientDataObject.myBillings.seconds99457) }}
													</span>
												</div>
											</v-progress-circular>
										</template>
										<span>{{ $t('data-transmission-for-16-days-or-more-within-a-30-day-period') }}</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template #activator="{ on, attrs }">
											<v-progress-circular
												:rotate="-90"
												:size="80"
												:width="2"
												:value="patientDataObject.myBillings.percent994581st"
												:color="patientDataObject.myBillings.percent994581st === 100 ? 'green' : 'primary'"
												class="font-size11 mx-1 px-2 font-weight-bold order-4"
												v-bind="attrs"
												v-on="on">
												<div class="d-flex flex-column">
													<span> 99458 1st </span>
													<span>
														{{ secToMinV2(patientDataObject.myBillings.seconds994581st) }}
													</span>
												</div>
											</v-progress-circular>
										</template>
										<span>{{ $t('20-additional-minutes-of-RPM-time') }}</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template #activator="{ on, attrs }">
											<v-progress-circular
												:rotate="-90"
												:size="80"
												:width="2"
												:value="patientDataObject.myBillings?.percent994582nd"
												:color="patientDataObject.myBillings?.percent994582nd === 100 ? 'green' : 'primary'"
												class="font-size11 mx-1 px-2 font-weight-bold order-5"
												v-bind="attrs"
												v-on="on">
												<div class="d-flex flex-column">
													<span> 99458 2nd </span>
													<span>
														{{ secToMinV2(patientDataObject.myBillings.seconds994582nd) }}
													</span>
												</div>
											</v-progress-circular>
										</template>
										<span>{{ $t('20-additional-minutes-of-RPM-time') }}</span>
									</v-tooltip>
								</div>
								<v-divider class="mt-3"></v-divider>
								<v-row dense class="d-flex justify-center mt-5" justify="space-around">
									<v-col cols="12">
										<v-card>
											<div class="d-flex align-center pa-2 my-n5">
												<v-progress-linear
													class="white--text"
													striped
													:value="getOverAllProgressFor(clickedFacilityId).toFixed(1)"
													:color="progressColor"
													height="25">
													{{ $t('progress') }}: {{ getOverAllProgressFor(clickedFacilityId).toFixed(1) }} %
												</v-progress-linear>
											</div>
										</v-card>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-card-text>
				</v-card>
				<v-card height="40vh" elevation="5" class="overflow-hidden">
					<v-card class="d-flex align-center py-1 border-radius0 ma-0" elevation="3" min-height="40px">
						<v-img class="ml-1" :src="info" min-height="20" max-width="22"></v-img>
						<div class="text-left font-weight-bold font-size15 ml-1">
							{{ $t('organization-revenue') }} : {{ authUserData.organizationAssignedData.institutionName }}
						</div>
					</v-card>
					<v-card-text class="pa-0 pt-2 ma-0 overflow-auto">
						<Graph
							ref="graphSeriesOrganization"
							type="bar"
							:options="chartOptionsOrganization"
							:series="graphSeriesOrganization"></Graph>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { billBlack, organizationsBlack, info } from '@/assets';
import Graph from 'vue-apexcharts';
import { getDataTableFooterProps, getRowsForDataTable } from '@/utils/utilities';
import { aggregateData } from '../../../utils/aggregateData';

export default {
	components: { Graph },
	data () {
		return {
			graphSeriesOrganization: [
				{
					name: this.$t('revenue'),
					data: [],
				},
			],
			chartOptionsOrganization: {
				chart: {
					type: 'bar',
					height: this.pageHeight < 800 ? 200 : 300,
					zoom: {
						enabled: true,
					},
				},
				dataLabels: {
					enabled: true,
					formatter: function (value) {
						// Format the value as currency
						return `${value.toFixed(0)}%`;
					},
					style: {
						fontSize: '12px',
						colors: ['#000'],
					},
				},
				stroke: {
					curve: 'smooth',
				},
				title: {
					text: '',
					align: 'left',
				},
				xaxis: {
					type: 'category',
					labels: {
						rotate: -60,
						trim: true,
						style: {
							fontSize: '12px',
							fontFamily: 'Arial, sans-serif',
						},
					},
				},
				yaxis: {
					opposite: false,
					min: 0,
					labels: {},
				},
				legend: {
					horizontalAlign: 'left',
				},
			},
			hospitalName: null,
			hospitalData: [],
			expanded: [],
			billingsNew: billBlack,
			info: info,
			clickedPatient: false,
			patientDataObject: null,
			hospitalSummary: {
				cpt99453: 0,
				cpt99454: 0,
				cpt99457: 0,
				cpt994581st: 0,
				cpt994582nd: 0,
			},
			facilitySearch: '',
			facilitiesTableLoader: false,
			sortBy: 'noteTimestamp',
			sortDesc: true,
			loader: false,
			lastValidHospitalId: null,
			billingSummary: {
				cpt99453: 0,
				cpt99454: 0,
				cpt99457: 0,
				cpt994581st: 0,
				cpt994582nd: 0,
			},
			clickedFacilityId: null,
			insideHeaders: [
				{
					text: this.$t('patient-name'),
					value: 'medicalNoteCategoryName',
					sortable: true,
					class: 'primary',
					align: 'start',
				},
				// { text: this.$t('age'), sortable: false, class: 'color-header', align: 'start' },
				{ text: '99445', sortable: false, class: 'color-header', align: 'start' },
				{ text: '99454', sortable: false, class: 'color-header', align: 'start' },
				{ text: '99470', sortable: false, class: 'color-header', align: 'start' },
				{ text: '99457', sortable: false, class: 'color-header', align: 'start' },
				{ text: '994581st', sortable: false, class: 'color-header', align: 'start' },
				{ text: '994582nd', sortable: false, class: 'color-header', align: 'start' },
				{ text: this.$t(''), sortable: false, class: 'color-header', align: 'start' },
				{ text: this.$t(''), sortable: false, class: 'color-header', align: 'start' },
			],
			facilityHeaders: [
				{ text: this.$t('hospital-name'), value: 'hospitalData.hospitalName', align: 'start', sortable: false },
				{ text: '', align: 'start', value: '', sortable: false },
				{ text: '', align: 'start', value: '', sortable: false },
				{ text: '', align: 'start', value: '', sortable: false },
				{ text: this.$t('billing-codes'), align: 'start', value: '', sortable: false },
				{ text: '', align: 'start', value: '', sortable: false },
				{ text: '', align: 'start', value: '', sortable: false },
				{ text: '', align: 'start', value: '', sortable: false },
				{ text: '', align: 'start', value: '', sortable: false },
			],
			facilityClicked: true,
			organizationBillingUnits: {},
			selectedFacilityBillingUnits: {},
			allHospitalsBillingUnitsData: [],
			facilityUserStatus: {},
			organizationUserStatus: {},
		};
	},
	computed: {
		...mapState({
			selectedMonthAndYear: (state) => state.filterbar.billingDate,
			authUserData: (state) => state.authentication.userData,
			billingsFromRepo: (state) => state.billings.billingSummaryForMonth,
		}),

		...mapGetters({
			pageHeight: 'pageHeight',
			roleName: 'authentication/getRole',
			userSettings: 'authentication/getUserSettings',
		}),
		progressColor () {
			const progress = this.getOverAllProgressFor(this.clickedFacilityId).toFixed(1);
			if (progress < 75) {
				return 'red'; // Color for progress less than 50
			} else if (progress >= 75 && progress < 100) {
				return 'orange'; // Color for progress between 50 and 75
			} else {
				return 'green'; // Color for progress 75 and above
			}
		},
		progressColorForOrganization () {
			const progress = this.getOverAllProgressForOrganization().toFixed(1);
			if (progress < 75) {
				return 'red'; // Color for progress less than 50
			} else if (progress >= 75 && progress < 100) {
				return 'orange'; // Color for progress between 50 and 75
			} else {
				return 'green'; // Color for progress 75 and above
			}
		},
		organizationsBlack () {
			return organizationsBlack;
		},
		filteredBillings () {
			const searchTerms = this.facilitySearch.toLowerCase().split(' ');
			return this.billingsFromRepo.filter((item) => {
				const email = item.patientData?.email.toLowerCase();
				const firstName = item.patientData?.firstName.toLowerCase();
				return searchTerms.every((term) => email?.includes(term) || firstName?.includes(term));
			});
		},
	},
	async created () {
		await this.getbillingsummaryforallpatientsformonth();
	},
	async mounted () {
		this.facilitiesTableLoader = true;
		this.toggleHeaders();
		this.facilitiesTableLoader = false;
	},
	watch: {
		selectedMonthAndYear (val) {
			if (val) {
				this.handleFacilityClick();
				this.getbillingsummaryforallpatientsformonth();
			}
		},
	},
	methods: {
		aggregateData,
		getRowsForDataTable,
		getDataTableFooterProps,
		progressColorForPatient (progress) {
			if (progress < 75) {
				return 'red'; // Color for progress less than 50
			} else if (progress >= 75 && progress < 100) {
				return 'orange'; // Color for progress between 50 and 75
			} else {
				return 'green'; // Color for progress 75 and above
			}
		},
		getPatientProgressForCPTCode (value) {
			if (value === null || value === undefined) return 0;
			const progress = parseInt(value, 10);
			return progress.toFixed(1);
		},
		getOverAllProgressFor (selectedHospitalId) {
			const automaticInitialReading =
				(parseFloat(this.getHospitalSummary(selectedHospitalId)?.percent99454) ?? 0) +
				(parseFloat(this.getHospitalSummary(selectedHospitalId)?.percent99445) ?? 0);
			const measurementTime =
				(parseFloat(this.getHospitalSummary(selectedHospitalId)?.percent99457) ?? 0) +
				(parseFloat(this.getHospitalSummary(selectedHospitalId)?.percent99470) ?? 0);
			var result =
				automaticInitialReading * (1 / 4) +
				measurementTime * (1 / 4) +
				this.getHospitalSummary(selectedHospitalId)?.percent994581st * (1 / 4) +
				this.getHospitalSummary(selectedHospitalId)?.percent994582nd * (1 / 4);
			if (isNaN(result)) result = 0;

			return result;
		},

		getOverAllProgressForOrganization () {
			const automaticInitialReading =
				(parseFloat(this.organizationBillingUnits.BillingUnits99445Percent) ?? 0) +
				(parseFloat(this.organizationBillingUnits.BillingUnits99454Percent) ?? 0);
			const measurementTime =
				(parseFloat(this.organizationBillingUnits.BillingUnits99457Percent) ?? 0) +
				(parseFloat(this.organizationBillingUnits.BillingUnits99470Percent) ?? 0);
			var result =
				automaticInitialReading * 0.25 +
				measurementTime * 0.25 +
				this.organizationBillingUnits.BillingUnits994581stPercent * 0.25 +
				this.organizationBillingUnits.BillingUnits994582ndPercent * 0.25;
			if (isNaN(result)) result = 0;
			return result;
		},
		async handleFacilityClick (val) {
			this.hospitalName = val?.hospitalData?.hospitalName;
			// this.medicalStaffTableLoader = true;
			this.clickedPatient = false;
			this.facilityClicked = true;
			this.medicalStaffClicked = false;
			if (val === undefined) {
				if (this.lastValidHospitalId !== null) {
					this.clickedFacilityId = this.lastValidHospitalId;
				} else {
					return;
				}
			} else {
				this.clickedFacilityId = val.hospitalId;
				this.lastValidHospitalId = val.hospitalId;
			}
			this.medicalStaffTableLoader = true;
			// await this.getbillingsummaryforallpatientsformonth();
			// this.calculateBillingUnitsForFacility();
			this.findBillingUnitsbyHospitalId(this.clickedFacilityId);
			this.calculatePatientStatusForFacility();
		},

		calculateBillingUnitsForOrganization () {
			// Count based on the value of the properties if they are true
			const userCount = this.billingsFromRepo.length;
			this.organizationBillingUnits = this.billingsFromRepo.reduce(
				(acc, item) => {
					if (item.myBillings.m99445IsBillable) acc.BillingUnits99445++;
					if (item.myBillings.m99454IsBillable) acc.BillingUnits99454++;
					if (item.myBillings.m99470IsBillable) acc.BillingUnits99470++;
					if (item.myBillings.m99457IsBillable) acc.BillingUnits99457++;
					if (item.myBillings.m994581stIsBillable) acc.BillingUnits994581st++;
					if (item.myBillings.m994582ndIsBillable) acc.BillingUnits994582nd++;
					return acc;
				},
				{
					BillingUnits99445: 0,
					BillingUnits99454: 0,
					BillingUnits99470: 0,
					BillingUnits99457: 0,
					BillingUnits994581st: 0,
					BillingUnits994582nd: 0,
				},
			);

			this.organizationBillingUnits.userCount = userCount;
			this.organizationBillingUnits.BillingUnits99445Percent =
				userCount > 0 ? ((this.organizationBillingUnits.BillingUnits99445 / userCount) * 100).toFixed(1) : 0;
			this.organizationBillingUnits.BillingUnits99454Percent =
				userCount > 0 ? ((this.organizationBillingUnits.BillingUnits99454 / userCount) * 100).toFixed(1) : 0;
			this.organizationBillingUnits.BillingUnits99470Percent =
				userCount > 0 ? ((this.organizationBillingUnits.BillingUnits99470 / userCount) * 100).toFixed(1) : 0;
			this.organizationBillingUnits.BillingUnits99457Percent =
				userCount > 0 ? ((this.organizationBillingUnits.BillingUnits99457 / userCount) * 100).toFixed(1) : 0;
			this.organizationBillingUnits.BillingUnits994581stPercent =
				userCount > 0 ? ((this.organizationBillingUnits.BillingUnits994581st / userCount) * 100).toFixed(1) : 0;
			this.organizationBillingUnits.BillingUnits994582ndPercent =
				userCount > 0 ? ((this.organizationBillingUnits.BillingUnits994582nd / userCount) * 100).toFixed(1) : 0;
			this.calculateBillingUnitsForFacilityV2();
		},

		calculatePatientStatusForFacility () {
			// Filter by hospitalId
			const filteredUsersByHospital = this.billingsFromRepo.filter(
				(item) => item.hospitalId === this.clickedFacilityId,
			);

			// Count based on the value of the properties if they are true
			this.facilityUserStatus = filteredUsersByHospital.reduce(
				(acc, item) => {
					if (item.patientData !== null && item.patientData !== undefined) {
						if (item.patientData.status === 1) acc.activeUsers++;
						if (item.patientData.status !== 1 && item.patientData.status !== 99) acc.inactiveUsers++;
						if (item.patientData.status === 99) acc.deceasedUsers++;
					}
					return acc;
				},
				{ activeUsers: 0, inactiveUsers: 0, deceasedUsers: 0 },
			);
		},

		calculateBillingUnitsForFacility () {
			// Filter by hospitalId
			const filteredByHospital = this.billingsFromRepo.filter((item) => item.hospitalId === this.clickedFacilityId);
			const userCount = filteredByHospital.length;

			// Count based on the value of the properties if they are true
			this.selectedFacilityBillingUnits = filteredByHospital.reduce(
				(acc, item) => {
					if (item.myBillings.m99445IsBillable) acc.BillingUnits99445++;
					if (item.myBillings.m99454IsBillable) acc.BillingUnits99454++;
					if (item.myBillings.m99470IsBillable) acc.BillingUnits99470++;
					if (item.myBillings.m99457IsBillable) acc.BillingUnits99457++;
					if (item.myBillings.m994581stIsBillable) acc.BillingUnits994581st++;
					if (item.myBillings.m994582ndIsBillable) acc.BillingUnits994582nd++;
					return acc;
				},
				{ BillingUnits99454: 0, BillingUnits99457: 0, BillingUnits994581st: 0, BillingUnits994582nd: 0 },
			);

			this.selectedFacilityBillingUnits.userCount = userCount;

			this.selectedFacilityBillingUnits.BillingUnits99445Percent =
				userCount > 0 ? ((this.selectedFacilityBillingUnits.BillingUnits99445 / userCount) * 100).toFixed(1) : 0;
			this.selectedFacilityBillingUnits.BillingUnits99454Percent =
				userCount > 0 ? ((this.selectedFacilityBillingUnits.BillingUnits99454 / userCount) * 100).toFixed(1) : 0;
			this.selectedFacilityBillingUnits.BillingUnits99470Percent =
				userCount > 0 ? ((this.selectedFacilityBillingUnits.BillingUnits99470 / userCount) * 100).toFixed(1) : 0;
			this.selectedFacilityBillingUnits.BillingUnits99457Percent =
				userCount > 0 ? ((this.selectedFacilityBillingUnits.BillingUnits99457 / userCount) * 100).toFixed(1) : 0;
			this.selectedFacilityBillingUnits.BillingUnits994581stPercent =
				userCount > 0 ? ((this.selectedFacilityBillingUnits.BillingUnits994581st / userCount) * 100).toFixed(1) : 0;
			this.selectedFacilityBillingUnits.BillingUnits994582ndPercent =
				userCount > 0 ? ((this.selectedFacilityBillingUnits.BillingUnits994582nd / userCount) * 100).toFixed(1) : 0;
		},

		calculateBillingUnitsForFacilityV2 () {
			// Get unique hospital IDs
			const uniqueHospitalIds = [...new Set(this.billingsFromRepo.map((item) => item.hospitalId))];

			// Initialize an array to store the results for all hospitals
			const allHospitalsBillingData = [];

			// Iterate through each unique hospital ID
			uniqueHospitalIds.forEach((hospitalId) => {
				const filteredByHospital = this.billingsFromRepo.filter((item) => item.hospitalId === hospitalId);
				const userCount = filteredByHospital.length;

				// Calculate billing units for the current hospital
				const selectedFacilityBillingUnits = filteredByHospital.reduce(
					(acc, item) => {
						if (item.myBillings.m99445IsBillable) acc.BillingUnits99445++;
						if (item.myBillings.m99454IsBillable) acc.BillingUnits99454++;
						if (item.myBillings.m99470IsBillable) acc.BillingUnits99470++;
						if (item.myBillings.m99457IsBillable) acc.BillingUnits99457++;
						if (item.myBillings.m994581stIsBillable) acc.BillingUnits994581st++;
						if (item.myBillings.m994582ndIsBillable) acc.BillingUnits994582nd++;
						return acc;
					},
					{
						BillingUnits99445: 0,
						BillingUnits99454: 0,
						BillingUnits99470: 0,
						BillingUnits99457: 0,
						BillingUnits994581st: 0,
						BillingUnits994582nd: 0,
					},
				);

				// Add user count and percentages
				selectedFacilityBillingUnits.userCount = userCount;
				selectedFacilityBillingUnits.BillingUnits99445Percent =
					userCount > 0 ? ((selectedFacilityBillingUnits.BillingUnits99445 / userCount) * 100).toFixed(1) : 0;
				selectedFacilityBillingUnits.BillingUnits99454Percent =
					userCount > 0 ? ((selectedFacilityBillingUnits.BillingUnits99454 / userCount) * 100).toFixed(1) : 0;
				selectedFacilityBillingUnits.BillingUnits99470Percent =
					userCount > 0 ? ((selectedFacilityBillingUnits.BillingUnits99470 / userCount) * 100).toFixed(1) : 0;
				selectedFacilityBillingUnits.BillingUnits99457Percent =
					userCount > 0 ? ((selectedFacilityBillingUnits.BillingUnits99457 / userCount) * 100).toFixed(1) : 0;
				selectedFacilityBillingUnits.BillingUnits994581stPercent =
					userCount > 0 ? ((selectedFacilityBillingUnits.BillingUnits994581st / userCount) * 100).toFixed(1) : 0;
				selectedFacilityBillingUnits.BillingUnits994582ndPercent =
					userCount > 0 ? ((selectedFacilityBillingUnits.BillingUnits994582nd / userCount) * 100).toFixed(1) : 0;

				// Add the hospital ID to the result
				selectedFacilityBillingUnits.hospitalId = hospitalId;

				// Store the result in the array
				allHospitalsBillingData.push(selectedFacilityBillingUnits);
			});

			// Now you have all the billing data for all hospitals in allHospitalsBillingData

			// If you need to set it to a component data property, do it here
			this.allHospitalsBillingUnitsData = allHospitalsBillingData;
		},
		findBillingUnitsbyHospitalId (hospitalId) {
			// return this.allHospitalsBillingUnitsData.find(item => item.hospitalId === hospitalId);
			return (
				this.allHospitalsBillingUnitsData.find((item) => item.hospitalId === hospitalId) || {
					BillingUnits99445: 0,
					BillingUnits99454: 0,
					BillingUnits99470: 0,
					BillingUnits99457: 0,
					BillingUnits994581st: 0,
					BillingUnits994582nd: 0,
					userCount: 0,
					BillingUnits99445Percent: '0.0',
					BillingUnits99454Percent: '0.0',
					BillingUnits99470Percent: '0.0',
					BillingUnits99457Percent: '0.0',
					BillingUnits994581stPercent: '0.0',
					BillingUnits994582ndPercent: '0.0',
					hospitalId: hospitalId,
				}
			);
		},
		findBillingUnitsbyHospitalIdV2 (hospitalId) {
			// return this.allHospitalsBillingUnitsData.find(item => item.hospitalId === hospitalId);
			return this.hospitalData[hospitalId];
		},
		calculateBillingUnitsForGivenFacilityId (facilityId) {
			// Filter by hospitalId
			const filteredByHospital = this.billingsFromRepo.filter((item) => item.hospitalId === facilityId);
			const userCount = filteredByHospital.length;

			// Count based on the value of the properties if they are true
			var selectedFacilityBillingUnits = filteredByHospital.reduce(
				(acc, item) => {
					if (item.myBillings.m99445IsBillable) acc.BillingUnits99445++;
					if (item.myBillings.m99454IsBillable) acc.BillingUnits99454++;
					if (item.myBillings.m99470IsBillable) acc.BillingUnits99470++;
					if (item.myBillings.m99457IsBillable) acc.BillingUnits99457++;
					if (item.myBillings.m994581stIsBillable) acc.BillingUnits994581st++;
					if (item.myBillings.m994582ndIsBillable) acc.BillingUnits994582nd++;
					return acc;
				},
				{ BillingUnits99454: 0, BillingUnits99457: 0, BillingUnits994581st: 0, BillingUnits994582nd: 0 },
			);

			selectedFacilityBillingUnits.userCount = userCount;
			selectedFacilityBillingUnits.BillingUnits99445Percent =
				userCount > 0 ? ((selectedFacilityBillingUnits.BillingUnits99445 / userCount) * 100).toFixed(1) : 0;
			selectedFacilityBillingUnits.BillingUnits99454Percent =
				userCount > 0 ? ((selectedFacilityBillingUnits.BillingUnits99454 / userCount) * 100).toFixed(1) : 0;
			selectedFacilityBillingUnits.BillingUnits99470Percent =
				userCount > 0 ? ((selectedFacilityBillingUnits.BillingUnits99470 / userCount) * 100).toFixed(1) : 0;
			selectedFacilityBillingUnits.BillingUnits99457Percent =
				userCount > 0 ? ((selectedFacilityBillingUnits.BillingUnits99457 / userCount) * 100).toFixed(1) : 0;
			selectedFacilityBillingUnits.BillingUnits994581stPercent =
				userCount > 0 ? ((selectedFacilityBillingUnits.BillingUnits994581st / userCount) * 100).toFixed(1) : 0;
			selectedFacilityBillingUnits.BillingUnits994582ndPercent =
				userCount > 0 ? ((selectedFacilityBillingUnits.BillingUnits994582nd / userCount) * 100).toFixed(1) : 0;

			return selectedFacilityBillingUnits;
		},

		populateFacilityGraphData () {
			const distinctHospitalData = this.billingsFromRepo
				.map((item) => item.hospitalData)
				.filter(
					(value, index, self) =>
						value && index === self.findIndex((t) => t?.id === value?.id && t?.hospitalName === value?.hospitalName),
				);

			const newData = distinctHospitalData.map((hospital) => {
				const hospitalBillingUnits = this.findBillingUnitsbyHospitalId(hospital.id) || {
					BillingUnits99445Percent: 0,
					BillingUnits99454Percent: 0,
					BillingUnits99470Percent: 0,
					BillingUnits99457Percent: 0,
					BillingUnits994581stPercent: 0,
					BillingUnits994582ndPercent: 0,
				};
				const automaticInitialReading =
					(parseFloat(hospitalBillingUnits.BillingUnits99454Percent) ?? 0) +
					(parseFloat(hospitalBillingUnits.BillingUnits99445Percent) ?? 0);
				const measurementTime =
					(parseFloat(hospitalBillingUnits.BillingUnits99470Percent) ?? 0) +
					(parseFloat(hospitalBillingUnits.BillingUnits99457Percent) ?? 0);
				let result =
					automaticInitialReading * 0.25 +
					measurementTime * 0.25 +
					hospitalBillingUnits.BillingUnits994581stPercent * 0.25 +
					hospitalBillingUnits.BillingUnits994582ndPercent * 0.25;

				if (isNaN(result)) result = 0;

				return {
					name: hospital.hospitalName,
					data: result,
				};
			});

			const seriesData = {
				name: this.$t('revenue'),
				data: newData.map((item) => item.data),
			};

			const categories = newData.map((item) => item.name);

			this.graphSeriesOrganization = [seriesData];
			if (!this.chartOptionsOrganization) {
				this.chartOptionsOrganization = {};
			}
			if (!this.chartOptionsOrganization.xaxis) {
				this.chartOptionsOrganization.xaxis = {};
			}
			if (!this.chartOptionsOrganization.yaxis) {
				this.chartOptionsOrganization.yaxis = {};
			}
			if (!this.chartOptionsOrganization.yaxis.labels) {
				this.chartOptionsOrganization.yaxis.labels = {};
			}

			this.chartOptionsOrganization.xaxis.categories = categories;

			// Update y-axis formatter to display percentages
			this.chartOptionsOrganization.yaxis.labels.formatter = function (value) {
				return `${value.toFixed(0)}%`;
			};

			if (this.$refs.graphSeriesOrganization) {
				this.$refs.graphSeriesOrganization.updateSeries(this.graphSeriesOrganization);
				this.$refs.graphSeriesOrganization.updateOptions(this.chartOptionsOrganization);
			}
			// if (this.$vuetify.breakpoint.width <= 1336 ? this.chartOptionsOrganization.chart.height === 200 : this.chartOptionsOrganization.chart.height === 300);

			if (this.$vuetify.breakpoint.width <= 1336) {
				this.chartOptionsOrganization.chart.height = 250;
			} else {
				this.chartOptionsOrganization.chart.height = 300;
			}
		},

		calculatePatientStatusForOrganization () {
			// Count based on the value of the properties if they are true
			this.organizationUserStatus = this.billingsFromRepo.reduce(
				(acc, item) => {
					if (item.patientData !== null && item.patientData !== undefined) {
						if (item.patientData.status === 1) acc.activeUsers++;
						if (item.patientData.status !== 1 && item.patientData.status !== 99) acc.inactiveUsers++;
						if (item.patientData.status === 99) acc.deceasedUsers++;
					}
					return acc;
				},
				{ activeUsers: 0, inactiveUsers: 0, deceasedUsers: 0 },
			);
		},
		async expand (item) {
			if (item === this.expanded[0]) this.expanded = [];
			else this.expanded = [item];
		},
		secToMinV2 (seconds) {
			const hours = Math.floor(seconds / 3600);
			const minutes = Math.floor((seconds % 3600) / 60);
			const remainingSeconds = seconds % 60;

			return `${hours > 0 ? hours + 'h ' : ''}${minutes > 0 ? minutes + 'm ' : ''}${remainingSeconds}s`;
		},
		handlePatientClick (item) {
			this.patientDataObject = item;
			this.clickedPatient = true;
			this.facilityClicked = false;
		},
		getHospitalSummary (selectedHospitalId) {
			let hospitalId = null;
			if (selectedHospitalId === null) {
				hospitalId = localStorage.getItem('selectedHospitalAssignedId');
			} else {
				hospitalId = selectedHospitalId;
			}

			if (!hospitalId) {
				return null;
			}

			if (hospitalId in this.hospitalData) {
				return this.hospitalData[hospitalId];
			} else {
				return null;
			}
		},
		/**
		 * Convert a duration in seconds into a human-readable string.
		 * @param {number} totalSeconds — the total number of seconds
		 * @returns {string} e.g. "1 day, 2 hours, 3 minutes, 4 seconds"
		 */
		formatDuration (totalSeconds) {
			const units = [
				{ label: 'day', seconds: 86400 },
				{ label: 'hour', seconds: 3600 },
				{ label: 'minute', seconds: 60 },
				{ label: 'second', seconds: 1 },
			];

			let remaining = totalSeconds;
			const parts = [];

			for (const { label, seconds } of units) {
				const amount = Math.floor(remaining / seconds);
				if (amount > 0) {
					parts.push(`${amount} ${label}${amount !== 1 ? 's' : ''}`);
					remaining %= seconds;
				}
			}

			// If all units were zero, show “0 seconds”
			return parts.length > 0 ? parts.join(', ') : '0 seconds';
		},
		formatDate (val) {
			// Parse the input date string
			const dateObject = new Date(val);
			// Format the date as "Month Day Year"
			return dateObject.toLocaleString('en-US', {
				month: 'short',
				day: 'numeric',
				year: 'numeric',
				hour: 'numeric',
				minute: 'numeric',
				hour12: true,
			});
		},
		async getbillingsummaryforallpatientsformonth () {
			let year, month;
			if (this.selectedMonthAndYear) {
				[year, month] = this.selectedMonthAndYear.split('-');
			} else {
				const today = new Date();
				year = today.getFullYear();
				month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
			}
			if (this.roleName === 'ORGANIZATION_ADMIN') {
				const headers = {
					organizationId: this.authUserData.organizationId,
					month: month,
					year: year,
				};
				this.loader = true;
				await this.$store.dispatch('billings/getbillingsummaryforallpatientsformonth', headers).then(async () => {
					this.hospitalData = await this.aggregateData(this.billingsFromRepo);
					this.calculateBillingUnitsForOrganization();
					this.calculatePatientStatusForOrganization();
					this.populateFacilityGraphData();
					this.loader = false;
				});
			}
			this.toggleHeaders();
		},
		toggleHeaders () {
			const table = this.$refs.table;
			if (table) {
				const openCache = table?.$vnode.componentInstance.openCache;
				if (openCache) {
					Object.keys(openCache).forEach((group) => {
						this.$set(openCache, group, this.clickedPatient);
					});
				}
			}
			const measurementTable = this.$refs.measurementTable;
			if (measurementTable) {
				const openCache = measurementTable?.$vnode.componentInstance.openCache;
				if (openCache) {
					Object.keys(openCache).forEach((group) => {
						this.$set(openCache, group, this.clickedPatient);
					});
				}
			}
		},
	},
};
</script>

<style scoped>
.v-card {
	margin-bottom: 20px;
}
</style>
